var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ButtonGroup, buttonGroupClasses } from '@mui/material';
import styled from '@mui/material/styles/styled';
var FbmButtonGroupRoot = styled(ButtonGroup)(function (_a) {
    var _b, _c;
    var variant = _a.variant, orientation = _a.orientation, theme = _a.theme;
    return _b = {
            boxShadow: 'none'
        },
        _b["& .".concat(buttonGroupClasses.grouped)] = {
            '&:not(:last-of-type)': __assign({}, (variant === 'contained' &&
                orientation === 'horizontal' && (_c = {},
                _c["&.".concat(buttonGroupClasses.disabled)] = {
                    borderColor: theme.palette.action.disabledBackground,
                    borderRight: 'none',
                },
                _c)))
        },
        _b;
});
var FbmButtonGroup = React.forwardRef(function (props, ref) {
    return (React.createElement(FbmButtonGroupRoot, __assign({ ref: ref }, props)));
});
FbmButtonGroup.defaultProps = {
    variant: 'contained',
    orientation: 'horizontal',
};
export default FbmButtonGroup;
